<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate-multiple"
  [fullScreen]="true"
>
  <div class="preloader">
    <div class="loaderSpin"></div>
  </div>
</ngx-spinner>
